// extracted by mini-css-extract-plugin
export var copyIcon = "_rh-2";
export var discountCard = "_rh-0";
export var discountCode = "_rh-3";
export var discountContent = "_rh-1";
export var loadingCard = "_rh-4";